module.exports = __webpack_public_path__ + "static/quem-somos-lg-7ddf5079444624d8e2c3f9be7f36d092.png";